import { createAction, props } from '@ngrx/store';
import { QualidadeConexao } from 'src/app/refact/shared/components/teste-conexao/entities/QualidadeConexao';

export const atualizarQualidadeConexao = createAction(
  '[Qualidade Conexao] Atualizar Qualidade da Conexão',
  props<{ qualidade: QualidadeConexao }>()
);